import React from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ZIndexContext = React.createContext(null);
const ZIndexContextProvider = ({ zIndexService, children }) => /* @__PURE__ */ React.createElement(ZIndexContext.Provider, { value: zIndexService }, children);
function withZIndexContext(Component) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(ZIndexContext.Consumer, null, (value) => /* @__PURE__ */ React.createElement(Component, __spreadProps(__spreadValues({}, props), { zIndexService: value })));
  };
}

export { ZIndexContext, ZIndexContextProvider, withZIndexContext };
//# sourceMappingURL=ZIndexContext.js.map
